import ButtonIcon from "#common/buttons/ButtonIcon"
import { COLOR_PRIMARY } from "#constants/Styles"
import {
	JobProfileTableStyleContextContexts,
	JobProfileTableStyleContextProvider,
} from "#job-profile/contexts/JobProfileTableStyleContext"
import DeleteIcon from "@mui/icons-material/Delete"
import { Stack, Typography } from "@mui/material"
import Paper from "@mui/material/Paper"
import { styled } from "@mui/material/styles"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell, { tableCellClasses } from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: COLOR_PRIMARY,
		color: theme.palette.common.white,
		fontSize: 16,
	},
}))

const TableRowStyle = ({ children }) => {
	return (
		<TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
			{children}
		</TableRow>
	)
}

export function TableBasicData({
	items,
	data,
	onDelete,
	onEdit,
	options,
	actions,
	noEdit = false,
}) {
	const itemsComponent = items.map((item, index) => {
		return <StyledTableCell {...item.props}>{item.label || item.name}</StyledTableCell>
	})
	return (
		<JobProfileTableStyleContextProvider data={data} options={options} items={items}>
			<TableContainer component={Paper}>
				<Table sx={{ minWidth: 420 }} aria-label="simple table">
					<TableHead>
						<TableRow>
							{itemsComponent}
							<StyledTableCell align="right">{actions}</StyledTableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						<TableItems {...{ items, data, onDelete, onEdit, options, noEdit }} />
					</TableBody>
				</Table>
			</TableContainer>
		</JobProfileTableStyleContextProvider>
	)
}

const TableItems = ({ data, items, onDelete, onEdit, options, noEdit }) => {
	let itemsRow = data.map((datum, index) => {
		return (
			<TableRowStyle>
				{items.map((item, index) => {
					return (
						<TableCell {...item.props}>
							<Typography sx={{}}>{datum[item.name]}</Typography>
						</TableCell>
					)
				})}
				<TableCell align="right">
					<TableButtons
						data={datum}
						onDelete={onDelete}
						onEdit={onEdit}
						noEdit={noEdit}
					/>
				</TableCell>
			</TableRowStyle>
		)
	})
	if (!itemsRow.length) return [<CompetenceTableNoItems {...{ options }} />]

	return itemsRow
}

const CompetenceTableNoItems = ({ options }) => {
	const { items } = JobProfileTableStyleContextContexts()
	return (
		<TableRowStyle>
			<TableCell
				component="th"
				scope="row"
				colSpan={items.length + 1}
				align="center" // centra horizontalmente
			>
				<Typography variant="h6" fontWeight="bold">
					{options?.noDataText || "No hay datos"}
				</Typography>
			</TableCell>
		</TableRowStyle>
	)
}

const TableButtons = ({ data, onDelete, onEdit, noEdit }) => {
	if (noEdit) return null
	return (
		<Stack direction="row" spacing={1} alignContent={"center"} justifyContent="right">
			{/* <ButtonIcon icon={<EditIcon color="primary" />} onClick={() => onEdit(id)} /> */}
			{typeof onDelete === "function" && (
				<ButtonIcon icon={<DeleteIcon color="error" />} onClick={() => onDelete(data)} />
			)}
		</Stack>
	)
}
